import React, { FC } from 'react';

import {
  FormFieldsGradientRow,
  FormFieldsIdentitySection,
  FormFieldsSection,
  FormFieldsUploadSection
} from '../components';

import { BG_COLOR_FIELDS, UPLOAD_FIELDS } from './BundleFormFields.consts';

export const BundleFormFields: FC = (): React.ReactElement => {
  return (
    <React.Fragment>
      <FormFieldsSection heading="Bundle">
        <FormFieldsIdentitySection />
      </FormFieldsSection>

      <FormFieldsSection
        heading="Bundle Design"
        description="Customize the bundle to fit your store theme."
        showSeparator
      >
        {/* TODO: Aligned with Jonathan — replace AcGradientInput (MUI) with new component when available */}
        <FormFieldsGradientRow fields={BG_COLOR_FIELDS} layout="half" />
        <FormFieldsUploadSection fields={UPLOAD_FIELDS} />
      </FormFieldsSection>
    </React.Fragment>
  );
};
